var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.425 25.823l1.402 1.403 11.802-11.802-1.402-1.404z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.202 13.69l-1.173 1.173-7.242-7.241 1.173-1.173a2.371 2.371 0 0 1 3.349 0l3.892 3.892a2.37 2.37 0 0 1 .001 3.349zm-3.448 25.582H9.379V9.896h19.328L14.083 24.521l-1.436 11.482 11.483-1.435 14.624-14.624v19.328zM15.758 27.117l5.775 5.776-6.601.825.826-6.601zm7.911 5.105l-7.24-7.24L32.385 9.024l7.241 7.242-15.957 15.956zM43.605 8.939l-3.893-3.893a4.359 4.359 0 0 0-6.155 0l-2.866 2.866H7.394v33.344h33.344V17.96l2.867-2.867a4.358 4.358 0 0 0 0-6.154z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8d05baa558597f636af76dc615ed2116.svg";
export { ForwardRef as ReactComponent };